module.exports = __webpack_public_path__ + "img/xxxxx.231d5900.png";